import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, nextTick } from "vue";

import { useMap } from "@/components/Map/mixins/useMap";
import ModuleContainer from "@/components/Map/ModuleContainer.vue";
import { useShow } from "@/hooks/useShow";
import { Layer } from "@/model";
import { DraggableSidebar } from "@hungpv97/vue-library-draggable";
import { updateMapLang } from "@/store/store-lang";
//
import enLang from "@/lang/en/style-control.json";
import circleStyleLang from "@/lang/en/style/circle-style.json";
import lineStyleLang from "@/lang/en/style/line-style.json";
import fillStyleLang from "@/lang/en/style/fill-style.json";
import symbolStyleLang from "@/lang/en/style/symbol-style.json";
import rasterStyleLang from "@/lang/en/style/raster-style.json";
import { AMapLayer } from "@/model/datasource/view/map";
import { MapSimple } from "@/interface/map";
import { KEY_BUILD } from "@/model/datasource/type";

export default /*#__PURE__*/_defineComponent({
  __name: 'style-control',
  setup(__props, { expose }) {

const [show, toggleShow] = useShow(false);
const { c_mapId, callMap, trans } = useMap();
updateMapLang(c_mapId.value, {
  map: { "style-control": enLang },
  "circle-style": circleStyleLang,
  "line-style": lineStyleLang,
  "fill-style": fillStyleLang,
  "symbol-style": symbolStyleLang,
  "raster-style": rasterStyleLang
});
const layer = ref();
const layer_map = ref<AMapLayer | undefined>(undefined);
const layer_map_component = computed(() => {
  return layer_map.value && layer_map.value.getComponentUpdate();
});
const open = (_layer: Layer) => {
  toggleShow(true);
  layer_map.value = undefined;
  nextTick(() => {
    layer_map.value = _layer.getView(KEY_BUILD.MAP);
    layer.value = layer_map.value.getValue();
  });
};
const close = () => {
  toggleShow(false);
  onClose();
};
const onClose = () => {
  layer_map.value = undefined;
  layer.value = undefined;
};
const onUpdateStyle = (value: any) => {
  if (!layer_map.value) {
    return;
  }
  callMap((map: MapSimple) => {
    if (!layer_map.value) {
      return;
    }
    layer_map.value.updateValue(map, value);
    layer.value = layer_map.value.getValue();
  });
};
expose({ open, close });

return { __sfc: true,show, toggleShow, c_mapId, callMap, trans, layer, layer_map, layer_map_component, open, close, onClose, onUpdateStyle, ModuleContainer, DraggableSidebar }
}

})